import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { BaseDataLayerKey } from "fond/project/panels/ExtendedDesign/BaseData/layers";
import { Store } from "fond/types";

export type BaseDataDrawState = {
  /** The base data layer being drawn on the map, if any. */
  drawingKey: BaseDataLayerKey | null;
};

const initialState: BaseDataDrawState = { drawingKey: null };

/**
 * Redux slice storing which base data layer is being drawn from the base data flyout.
 */
export const baseDataDrawSlice = createSlice({
  name: "baseDataDraw",
  initialState,
  reducers: {
    setBaseDataDrawingKey: (state, action: PayloadAction<BaseDataLayerKey | null>): BaseDataDrawState => ({ drawingKey: action.payload }),
  },
});

export const { setBaseDataDrawingKey } = baseDataDrawSlice.actions;

/** The base data layer being drawn on the map, if any. */
export const selectBaseDataDrawingKey = (state: Store): BaseDataLayerKey | null => state.baseDataDraw.drawingKey;
